export const CardFromElement =  ()=>{
    return (
        <div className="container">
            モンスター場所fromはカードがどの場所から来たかを表します。以下の例では手札からカードが来たことを表します
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_card_from.png`}></img></p>
        </div>
    )
}
